import { useEffect, useState } from 'react';
import { ADDRESS_TYPES, INIT_SPECIFIC_TEXT_INPUT_ERROR } from './constants';

const useAddressStates = ({ usedAddresses = [], initAddress = null, onClose = () => {} }) => {
  const [addressType, setAddressType] = useState("home");
  const [streetAddress, setStreetAddress] = useState('');
  const [secondaryAddress, setSecondaryAddress] = useState('');
  const [city, setCity] = useState('');
  const [locality, setLocality] = useState('');
  const [country, setCountry] = useState('US');
  const [postalCode, setPostalCode] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [specificTextInputError, setSpecificTextInputError] = useState(INIT_SPECIFIC_TEXT_INPUT_ERROR);

  useEffect(() => {
    if (initAddress) {
      setAddressType(initAddress?.addressType || "home");
      setStreetAddress(initAddress?.streetAddress || '');
      setSecondaryAddress(initAddress?.secondaryAddress || '');
      setCity(initAddress?.city || '');
      setLocality(initAddress?.locality || '');
      setPostalCode(initAddress?.postalCode || '');
      setCountry(initAddress?.country || 'US');
    } else {
      setAddressType(ADDRESS_TYPES.find((type) => !usedAddresses.map(address => address.addressType).includes(type.value))?.value ||
        "other");
    }
  }, [initAddress, usedAddresses]);

  const onCloseHandlr = () => {
    setAddressType("home");
    setStreetAddress('');
    setCity('');
    setLocality('');
    setPostalCode('');
    setError(null);
    setSecondaryAddress('');
    setSpecificTextInputError(INIT_SPECIFIC_TEXT_INPUT_ERROR);
    onClose();
  }

  return {
    addressType,
    addressTypes: ADDRESS_TYPES,
    streetAddress,
    city,
    locality,
    postalCode,
    country,
    isLoading,
    secondaryAddress,
    error,
    specificTextInputError,
    setAddressType,
    setStreetAddress,
    setCity,
    setLocality,
    setPostalCode,
    setCountry,
    setIsLoading,
    setSecondaryAddress,
    setError,
    setSpecificTextInputError,
    onCloseHandlr
  };
};

export default useAddressStates;